import React from 'react';

import { NodeView } from './NodeView';

import { GenericHierarchyFlow } from 'common/components/PreviewApprovalHierarchyReactFlow';
import {
  TravelAuthorizationPreviewApprovalMap,
  TravelAuthorizationPreviewApprovalMapVariables,
  TravelAuthorizationPreviewApprovalMap_travelAuthorizationPreviewApprovalMap_nodes,
} from './__generated__/TravelAuthorizationPreviewApprovalMap';

import TRAVEL_AUTHORIZATION_PREVIEW_APPROVAL_MAP from './TravelAuthorizationPreviewApprovalMap.graphql';

export interface HierarchyNode
  extends TravelAuthorizationPreviewApprovalMap_travelAuthorizationPreviewApprovalMap_nodes {
  children?: HierarchyNode[];
  width?: number;
  height?: number;
}

interface HierarchyComponentProps {
  entityId: string | undefined;
}

const getNodesFromData = (data: TravelAuthorizationPreviewApprovalMap) => {
  return data?.travelAuthorizationPreviewApprovalMap?.nodes?.map((node) => ({
    ...node,
    level: node.level ?? 0,
    width: 300,
    height: 200,
    children: [], // Ensure children is included
  }));
};

export const HierarchyComponent: React.FC<HierarchyComponentProps> = ({
  entityId,
}) => {
  if (!entityId) return null;

  return (
    <GenericHierarchyFlow<
      TravelAuthorizationPreviewApprovalMap,
      TravelAuthorizationPreviewApprovalMapVariables
    >
      entityId={entityId}
      query={TRAVEL_AUTHORIZATION_PREVIEW_APPROVAL_MAP}
      queryVariables={{ entityId }}
      getNodesFromData={getNodesFromData}
      NodeViewComponent={(props) => (
        <NodeView
          nodeData={props.data as unknown as HierarchyNode}
          key={props.data.id}
        />
      )}
    />
  );
};
